import { cn } from '@/lib/utils'

/** Default visual treatment for form controls across the portal. */
export const FORM_CONTROL_BASE_CLASS =
  'border-transparent bg-[#f5f6fa] text-sm font-normal text-[#171a20]'

/** Shared focus treatment for inputs and textareas. */
export const FORM_CONTROL_FOCUS_CLASS =
  'focus:border-[#ff5a1f] focus:outline-none focus:ring-1 focus:ring-[#ff5a1f] focus:ring-offset-2 focus:ring-offset-white focus:shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] focus-visible:border-[#ff5a1f] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#ff5a1f] focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)]'

/** Keeps the focus treatment visible while a custom filter popover is open. */
export const FORM_CONTROL_OPEN_CLASS =
  'border-[#ff5a1f] outline-none ring-1 ring-[#ff5a1f] ring-offset-2 ring-offset-white shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] hover:border-[#ff5a1f]'

/** List-filter hover treatment; leaves the control's surface and text unchanged. */
export const FORM_FILTER_HOVER_CLASS = 'hover:border-[#D5D8DF]'

/** Focus treatment for controls that contain a nested input. */
export const FORM_CONTROL_FOCUS_WITHIN_CLASS =
  'focus-within:border-[#ff5a1f] focus-within:outline-none focus-within:ring-1 focus-within:ring-[#ff5a1f] focus-within:ring-offset-2 focus-within:ring-offset-white focus-within:shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)]'

/** Radix Select keeps its trigger open instead of exposing native focus. */
export const FORM_CONTROL_SELECT_OPEN_CLASS =
  'focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:border-[#ff5a1f] data-[state=open]:shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05),0px_0px_0px_2px_#fff,0px_0px_0px_3px_#ff5a1f]'

export const FORM_CONTROL_CLASS = cn(
  FORM_CONTROL_BASE_CLASS,
  FORM_CONTROL_FOCUS_CLASS
)

export const FORM_CONTROL_SELECT_CLASS = cn(
  FORM_CONTROL_BASE_CLASS,
  FORM_CONTROL_SELECT_OPEN_CLASS
)

export const FORM_FIELD_TYPOGRAPHY_CLASS =
  'font-sans text-sm font-normal leading-[1.4] text-[#171a20] placeholder:font-normal placeholder:text-[#6c7285]'

export const FORM_FIELD_CLASS = cn(
  'h-10 rounded-xl border-transparent bg-[#f5f6fa] px-4 py-3 shadow-none',
  FORM_FIELD_TYPOGRAPHY_CLASS,
  FORM_CONTROL_FOCUS_CLASS
)

export const FORM_FIELD_WITHIN_CLASS = cn(
  'flex h-10 w-full items-center gap-2 rounded-xl border border-transparent bg-[#f5f6fa] px-4 py-3 shadow-none',
  FORM_CONTROL_FOCUS_WITHIN_CLASS
)

export const FORM_TEXTAREA_CLASS = cn(
  'min-h-20 rounded-xl border-transparent bg-[#f5f6fa] px-4 py-3 shadow-none',
  FORM_FIELD_TYPOGRAPHY_CLASS,
  FORM_CONTROL_FOCUS_CLASS
)

export const FORM_DATE_FIELD_CLASS = cn(
  FORM_FIELD_WITHIN_CLASS,
  '[&_input]:font-sans [&_input]:text-sm [&_input]:font-normal [&_input]:leading-[1.4] [&_input]:text-[#171a20] [&_input]:placeholder:text-[#6c7285] data-[has-value=true]:[&_input]:font-normal'
)
